// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3lQJ6","messages":"Chat_messages__1iypW","dateDivider":"Chat_dateDivider__1oxKu"};